<template>
  <svg
    class="tiktok-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 17"
    fill="currentColor"
  >
    <path
      d="M14.3146 4.97107C13.4001 4.97107 12.5562 4.66813 11.8787 4.15702C11.1016 3.57107 10.5432 2.71169 10.3461 1.72111C10.297 1.47631 10.2709 1.22369 10.2682 0.964844H7.65577V8.10333L7.65257 12.0134C7.65257 13.0587 6.97186 13.9451 6.02821 14.2568C5.75444 14.3472 5.45861 14.3901 5.15053 14.3732C4.75746 14.3517 4.3891 14.2329 4.06893 14.0415C3.3875 13.634 2.92564 12.8946 2.91301 12.0489C2.89328 10.7272 3.9619 9.64964 5.28261 9.64964C5.54341 9.64964 5.79373 9.69213 6.02821 9.76947V7.81853V7.1172C5.78093 7.08058 5.52937 7.06155 5.27479 7.06155C3.8291 7.06155 2.4771 7.66244 1.51053 8.74511C0.780037 9.56324 0.341815 10.607 0.274259 11.7016C0.185726 13.1394 0.71177 14.5062 1.73221 15.5147C1.88208 15.6628 2.03959 15.8002 2.20421 15.927C3.07906 16.5999 4.14857 16.9648 5.27497 16.9648C5.52937 16.9648 5.7811 16.946 6.02839 16.9094C7.08066 16.7535 8.0515 16.2719 8.81773 15.5144C9.75924 14.5839 10.2794 13.3485 10.2849 12.0336L10.2714 6.19471C10.7205 6.5412 11.2117 6.82795 11.7386 7.05035C12.5583 7.39613 13.4275 7.57142 14.3219 7.57124V5.67435V4.97053C14.3226 4.97107 14.3151 4.97107 14.3146 4.97107Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'Tiktok',
};
</script>

<style scoped>
.tiktok-icon {
  width: 1em;
  height: 1em;
  display: inline-block;
  vertical-align: -0.125em;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// TiktokIcon.vue?14668c97